import React, { Component } from 'react';
import axios from 'axios';
import Thanks from '../Thanks';
import { Input, Select, SelectWithNameValues, Textarea } from '../forms/input';
class Offer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.hideThanksModal = this.hideThanksModal.bind(this);
  }
  handleChange(param, value) {
    if (param == 'nda') {
      if (value) value = 'Yes';
      else value = 'No';
    }
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
  }
  onSubmit(e) {
    e.preventDefault();
    var that = this;
    var form_data = new FormData(e.target);
    for (var key in this.state.formdata) {
      form_data.append(key, this.state.formdata[key]);
    }
    let arr = [];
    this.props.selectedArtists.forEach(artist => arr.push(artist.artist_name));
    form_data.append('artists', arr.join(','));
    form_data.append('country', this.props.country);
    // that.props.hide();
    // that.setState({showThanks:true});
    document.body.style.overflow = 'hidden';
    const action = this.props.action ? this.props.action : 'https://mailer.weprodigi.com/actions/voiceClient.php';
    axios.post(action, form_data).then(response => {
      // that.setState({loadedThanks:true});
      window.location.href = 'https://weprodigi.com/thank-you';
    });
    // e.target.reset()
  }
  hideModal = () => {
    if (!this.props.popupSelectTextes) document.getElementById('nda').checked = false;
    document.getElementById('name').value = '';
    document.getElementById('email').value = '';
    document.querySelector('input[name="email"]').value = '';
    document.querySelector('input[name="name"]').value = '';
    document.querySelector('input[name="phone"]').value = '';
    document.querySelector('select[name="industry"]').value = '';
    document.querySelector('textarea[name="comments"]').value = '';
    document.getElementById('offer-form').reset();
    this.props.hide();
  };
  render() {
    return (
      <>
        <div
          className={
            'MontserratArm fixed z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center' +
            ' ' +
            (this.props.show && !this.state.showThanks ? 'flex' : 'hidden')
          }
        >
          <div className="absolute left-0 top-0 w-full h-full" onClick={this.hideModal} />
          <div className={`relative w-11/12   max-w-screen-md  bg-white border border-gray-transparent rounded-5 `}>
            <div
              onClick={this.hideModal}
              className="absolute -right-12 -top-12 bg-purple text-white w-30 h-30 text-21 rounded-full flex items-center justify-center cursor-pointer select-none"
            >
              <span className="font-bold">X</span>
            </div>
            <div className="p-23">
              <p className="text-purple uppercase text-30 text-center font-black leading-none">
                {this.props.offerTitle ? this.props.offerTitle : 'video request'}
              </p>
              <p className="text-black normal-case text-18 text-center font-black mt-5 mb-15 leading-none">{this.props.title}</p>
              <form id="offer-form" method="POST" action="https://mailer.weprodigi.com/actions/1.php" onSubmit={e => this.onSubmit(e)}>
                <input type="hidden" name="service" value={this.props.title} />
                <input type="hidden" name="budget" value={this.props.offerPrice || ''} />
                <div className="md:grid md:grid-cols-2 gap-x-23">
                  <div>
                    <Input
                      type="text"
                      id="name"
                      name="name"
                      label={this.props.name ? this.props.name : 'Your Name*'}
                      bg="bg-gray-light"
                      required={true}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div>
                    <Input
                      type="text"
                      name="phone"
                      label={this.props.phone ? this.props.phone : 'Phone Number'}
                      bg="bg-gray-light"
                      onChange={this.handleChange}
                    />
                  </div>
                  <div>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      label={this.props.email ? this.props.email : 'Email*'}
                      bg="bg-gray-light"
                      required={true}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div>
                    {this.props.popupSelectTextes ? (
                      <SelectWithNameValues
                        selectText={this.props.selectText}
                        name="industry"
                        label={this.props.industry ? this.props.industry : 'Industry'}
                        bg="bg-gray-light"
                        onChange={this.handleChange}
                        values={this.props.popupSelectTextes}
                      />
                    ) : (
                      <Select
                        selectText={this.props.selectText}
                        name="industry"
                        label={this.props.industry ? this.props.industry : 'Industry'}
                        bg="bg-gray-light"
                        onChange={this.handleChange}
                        values={[
                          'Operations Manager',
                          'Accounting and Finance',
                          'Construction',
                          'Creative and Design',
                          'Customer Service',
                          'Education',
                          'Energy and Utilities',
                          'Engineering',
                          'Financial Services',
                          'Healthcare',
                          'IT',
                          'Legal',
                          'Marketing and Advertising',
                          'Other',
                        ]}
                      />
                    )}
                  </div>
                  <div className="col-span-2">
                    <Textarea
                      name="comments"
                      label={this.props.comments ? this.props.comments : 'Comments'}
                      bg="bg-gray-light resize-none"
                      placeholder=""
                      onChange={this.handleChange}
                    ></Textarea>
                  </div>
                  {!this.props.popupSelectTextes && (
                    <div className="form-group mr-30">
                      <label className="relative pl-30 cursor-pointer text-purple  text-purple text-14 md:text-18 flex items-center">
                        <input
                          id="nda"
                          className="absolute cursor-pointer opacity-0"
                          onChange={e => this.handleChange('nda', e.target.checked)}
                          type="checkbox"
                          name="nda"
                        />
                        <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                        Send NDA
                      </label>
                    </div>
                  )}
                  <input type="hidden" name="country" value={this.props.country} />
                  <div className="col-span-2">
                    <button
                      id="offer-submit"
                      type="submit"
                      className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                    >
                      {this.props.send ? this.props.send : 'Submit'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Thanks
          from={this.props.from}
          show={this.state.showThanks}
          loaded={this.state.loadedThanks}
          hide={this.hideThanksModal}
          tnx={this.props.tnx}
          goBack={this.props.goBack}
        >
          <p>
            {this.props.thanksTitle ? this.props.thanksTitle : 'Something great is headed your way!'} <br />
            <br />
            {this.props.thanksText
              ? this.props.thanksText
              : ' Our sales specialist will get back to you as soon as possible. If you don’t receive an email from us within 24 hours please check your Spam Box.'}
          </p>
        </Thanks>
      </>
    );
  }
}
export default Offer;
